import { Controller } from "@hotwired/stimulus"

// Copy text to clipboard with brief "Copied!" feedback on the button.
export default class extends Controller {
  static values = { text: String }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.textValue)
      const btn = this.element
      const original = btn.innerHTML
      btn.innerHTML = `<svg class="w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/></svg><span>Copied!</span>`
      setTimeout(() => { btn.innerHTML = original }, 1500)
    } catch (err) {
      console.error("Copy failed:", err)
    }
  }
}
